


























import CalculatorForm from "@/components/CalculatorForm.vue"
import { Component, Vue } from "vue-property-decorator"

@Component({ components: { CalculatorForm } })
export default class App extends Vue {
  public langs = ["fr", "en"]

  constructor() {
    super()
  }

  public toggleIsFormOpen(): void {
    this.$store.commit("toggleIsFormOpen")
  }

  public get isFormOpen(): boolean {
    return this.$store.state.isFormOpen
  }

  public set isFormOpen(v: boolean) {
    this.$store.state.isFormOpen = v;
  }
}
